/**
 * Small "Connect GitHub repos" link for the project page's Sources header.
 * Sends the user to the GitHub App install screen and — via the remembered
 * return path — brings them back to this project afterwards, where the
 * Add-source picker will list the newly connected repos.
 */
import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import { rememberGithubReturnPath } from './returnPath';

export function GithubProjectConnectLink() {
  const [installUrl, setInstallUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.getGithubAppInfo()
      .then((info) => {
        if (!cancelled && info.configured && info.installUrl) setInstallUrl(info.installUrl);
      })
      .catch(() => { /* hidden when unavailable */ });
    return () => { cancelled = true; };
  }, []);

  if (!installUrl) return null;

  return (
    <a
      href={installUrl}
      onClick={() => rememberGithubReturnPath()}
      className="text-xs px-2 py-0.5 rounded border border-primary/40 text-primary hover:bg-primary/10 transition-colors"
      title="Grant read-only access to more repositories on GitHub, then add them as sources"
    >
      Connect GitHub repos
    </a>
  );
}
